<ng-template #content let-data="data">
  <p class="m-0 mb-2">{{ data.message }}</p>
  @if (canReport()) {
    <a class="cursor-pointer font-semibold text-main-color underline" (click)="openReport(data)">
      Click here if you want to report this issue
    </a>
  }
</ng-template>

<dlap-lodge-ticket-modal [(visible)]="isReportOpen" [context]="reportContext()" />
